(function () {
  const header = document.querySelector('[data-routed-header]');
  if (!header) return;

  /* ---------- Scroll state (curved → stacked logo) ---------- */
  const SCROLL_THRESHOLD = 60;

  const onScroll = () => {
    if (window.scrollY > SCROLL_THRESHOLD) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  };

  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------- Mega menu open/close ---------- */
  const triggers = header.querySelectorAll('[data-routed-trigger]');
  const panels = header.querySelectorAll('[data-routed-panel]');

  const closeAll = () => {
    triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
    panels.forEach((p) => p.setAttribute('hidden', ''));
  };

  triggers.forEach((trigger) => {
    const id = trigger.dataset.routedTrigger;
    const panel = header.querySelector(`[data-routed-panel="${id}"]`);
    if (!panel) return;

    const open = () => {
      closeAll();
      trigger.setAttribute('aria-expanded', 'true');
      panel.removeAttribute('hidden');
    };

    // Open on hover or keyboard focus
    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('focus', open);

    // Click toggles (useful on touch / accessibility)
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        closeAll();
      } else {
        open();
      }
    });

    // Keep panel open while hovering the panel itself
    const panelMatch = header.querySelector(`[data-routed-panel="${id}"]`);
    if (panelMatch) {
      panelMatch.addEventListener('mouseenter', open);
    }
  });

  // Close when the mouse leaves the whole header area
  header.addEventListener('mouseleave', closeAll);

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
})();
/* ============================================================
   SEARCH DRAWER
   ============================================================ */
(function () {
  const drawer = document.querySelector('[data-routed-search]');
  if (!drawer) return;

  const openButtons = document.querySelectorAll('[data-search-open]');
  const closeButtons = drawer.querySelectorAll('[data-search-close]');
  const input = drawer.querySelector('[data-search-input]');
  const resultsWrap = drawer.querySelector('[data-search-results]');
  const resultsList = drawer.querySelector('[data-search-results-list]');
  const viewAll = drawer.querySelector('[data-search-view-all]');
  const emptyState = drawer.querySelector('[data-search-empty]');
  const emptyQuery = drawer.querySelector('[data-search-query]');
  const hint = drawer.querySelector('[data-search-hint]');

  let debounceTimer = null;
  let currentQuery = '';

  // ----- Open / Close -----
  function openDrawer() {
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      setTimeout(() => input.focus(), 200);
    });
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(() => {
      drawer.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
    }, 350);
  }

  openButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openDrawer();
    });
  });

  closeButtons.forEach((btn) => {
    btn.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // ----- Search input -----
  input.addEventListener('input', (e) => {
    const query = e.target.value.trim();
    currentQuery = query;

    clearTimeout(debounceTimer);

    if (query.length < 2) {
      // Show hint, hide results
      resultsWrap.hidden = true;
      emptyState.hidden = true;
      hint.hidden = false;
      return;
    }

    // Debounce: wait 200ms after user stops typing
    debounceTimer = setTimeout(() => {
      fetchPredictiveSearch(query);
    }, 200);
  });

  // ----- Predictive search fetch -----
  async function fetchPredictiveSearch(query) {
    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
      const response = await fetch(url);
      if (!response.ok) throw new Error('Search failed');
      const data = await response.json();

      // Make sure the user hasn't typed something else by the time we got back
      if (query !== currentQuery) return;

      const products = (data.resources && data.resources.results && data.resources.results.products) || [];
      renderResults(products, query);
    } catch (err) {
      console.error('[Routed Search] Error:', err);
      hint.hidden = true;
      resultsWrap.hidden = true;
      emptyState.hidden = false;
      emptyQuery.textContent = query;
    }
  }

  // ----- Render results -----
  function renderResults(products, query) {
    hint.hidden = true;

    if (products.length === 0) {
      resultsWrap.hidden = true;
      emptyState.hidden = false;
      emptyQuery.textContent = query;
      return;
    }

    emptyState.hidden = true;
    resultsWrap.hidden = false;

    resultsList.innerHTML = products.map((p) => {
      const image = p.featured_image ? p.featured_image.url : (p.image || '');
      const imageHTML = image
        ? `<div class="routed-search__result-image"><img src="${escapeAttr(image)}" alt="${escapeAttr(p.title)}" loading="lazy"></div>`
        : '<div class="routed-search__result-image"></div>';

      return `
        <a href="${escapeAttr(p.url)}" class="routed-search__result">
          ${imageHTML}
          <div class="routed-search__result-info">
            <h3 class="routed-search__result-title">${escapeHtml(p.title)}</h3>
            <span class="routed-search__result-price">${formatPrice(p.price)}</span>
          </div>
        </a>
      `;
    }).join('');

    // Update the "View all results" link
    viewAll.href = `/search?q=${encodeURIComponent(query)}&type=product`;
    viewAll.hidden = false;
  }

  // ----- Helpers -----
  function formatPrice(price) {
    if (price == null) return '';
    // Shopify predictive search returns price as a string like "$35.00" already formatted, but be defensive
    if (typeof price === 'string') return price;
    const dollars = (parseInt(price, 10) / 100).toFixed(2);
    return `$${dollars}`;
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function escapeAttr(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
})();

/* ============================================================
   DROPS MENU — PRODUCT CAROUSEL
   ============================================================ */
(function () {
  const carousels = document.querySelectorAll('[data-drop-carousel]');
  if (!carousels.length) return;

  carousels.forEach((carousel) => {
    const track = carousel.querySelector('[data-drop-track]');
    const prev = carousel.querySelector('[data-drop-prev]');
    const next = carousel.querySelector('[data-drop-next]');
    if (!track || !prev || !next) return;

    // Scroll by one visible "page" of cards
    const page = () => Math.max(track.clientWidth * 0.85, 200);

    const update = () => {
      const scrollable = track.scrollWidth > track.clientWidth + 4;
      prev.hidden = !scrollable;
      next.hidden = !scrollable;
      if (!scrollable) return;
      const maxScroll = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
    };

    prev.addEventListener('click', () => { track.scrollBy({ left: -page(), behavior: 'smooth' }); });
    next.addEventListener('click', () => { track.scrollBy({ left: page(), behavior: 'smooth' }); });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    // Recheck when the panel opens (it starts hidden, so widths read 0 until shown)
    const panel = carousel.closest('[data-routed-panel]');
    if (panel) {
      const obs = new MutationObserver(() => {
        if (!panel.hasAttribute('hidden')) requestAnimationFrame(update);
      });
      obs.observe(panel, { attributes: true, attributeFilter: ['hidden'] });
    }

    update();
  });
})();

/* ============================================================
   MOBILE NAV DRAWER
   ============================================================ */
(function () {
  const nav = document.querySelector('[data-mobile-nav]');
  const burger = document.querySelector('[data-routed-burger]');
  if (!nav || !burger) return;

  const closers = nav.querySelectorAll('[data-mobile-nav-close]');

  function open() {
    nav.hidden = false;
    nav.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(() => nav.classList.add('is-open'));
    document.body.style.overflow = 'hidden';
  }
  function close() {
    nav.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(() => {
      nav.hidden = true;
      nav.setAttribute('aria-hidden', 'true');
    }, 320);
  }

  burger.addEventListener('click', open);
  closers.forEach((c) => c.addEventListener('click', close));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && nav.classList.contains('is-open')) close();
  });
  // Accordion toggles — expand/collapse sub-menus
  nav.querySelectorAll('[data-mnav-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const item = btn.closest('[data-mnav-item]');
      const sub = item.querySelector('[data-mnav-sub]');
      const isOpen = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      sub.style.maxHeight = isOpen ? sub.scrollHeight + 'px' : null;
    });
  });

  // Close the whole drawer when tapping any actual link (label or sub-link)
  nav.querySelectorAll('.routed-mnav-label, .routed-mnav-sub a').forEach((a) => {
    a.addEventListener('click', close);
  });
})();